"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAnalyticsInterface = void 0;
const disabled_1 = require("./disabled");
const googleAnalytics_1 = require("./googleAnalytics");
const createAnalyticsInterface = (config) => {
    switch (config.serviceName) {
        case "googleAnalytics":
            return (0, googleAnalytics_1.createGoogleAnalyticsInterface)(config);
        default:
            return (0, disabled_1.createDisabledAnalyticsInterface)(config);
    }
};
exports.createAnalyticsInterface = createAnalyticsInterface;
